<template>
    <ul class="nav nav-tabs mt-4 account-tabs">
        <li class="nav-item account-tabs__item" v-for="(page, i) in pages" :key="i">
            <router-link :to="page.path" :class="[{active: page.isActive}, 'nav-link']">
                {{ page.name }}
                <template v-if="page.num > 0">({{ page.num }})</template>
            </router-link>
        </li>
    </ul>
</template>

<style lang="scss">
    @import "../scss/variables";

    .account-tabs {
        border-bottom: none !important;

        &__item {
            margin-right: 10px;
            margin-bottom: 0;

            &:last-child {
                margin-right: 0;
            }

            > a {
                display: inline-flex;
                align-items: center;
                justify-content: center;
                padding: 0 1.75rem;
                height: 50px;
                border-radius: 25px !important;
                background-color: var(--bg-color);
                border: none !important;
                box-shadow: 0 2px 2px 0 rgba(#000, .14), 0 3px 1px -2px rgba(#000, .12), 0 1px 2px 0 rgba(#000, .2);

                &,
                &:hover,
                &:focus {
                    color: inherit;
                    text-decoration: none;
                }

                &.active {
                    color: #fff !important;
                    background-color: var(--primary-color) !important;
                }
            }
        }
    }

    body.-is-mobile {

        .account-tabs {
            flex-direction: column;

            &__item {
                margin-right: 0;

                > a {
                    width: 100%;
                    border-radius: 0 !important;
                    box-shadow: none;
                    border: 1px solid rgba(#000, .125) !important;
                    border-top: none;
                }

                &:first-child > a {
                    border-top: 1px solid rgba(#000, .125) !important;
                    border-top-left-radius: .3rem !important;
                    border-top-right-radius: .3rem !important;
                }

                &:last-child > a {
                    border-bottom-left-radius: .3rem !important;
                    border-bottom-right-radius: .3rem !important;
                }
            }
        }
    }
</style>

<script>
  import accountTabs from 'src/mixins/accountTabsComponent';

  export default {
    mixins: [accountTabs],
  };
</script>
